export default __webpack_public_path__ + "static/media/BZ.90afec83.svg";